export enum DecimeterPosition {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}